import React from "react";

// Material UI Components
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

import Select from "components/selects/Select/Select.component";
import LocationSearch from "components/inputs/LocationSearch/LocationSearch.component";

import usePageWidth from "hooks/usePageWidth.hook";

// Styles
import { useStyles } from "./LocationForm.styles";

const radiuses = [25, 50, 100, 250, 500];

// radius, setRadius, provinceOnly, setProvinceOnly,
const LocationForm = ({ clearInventoryCards, locationFormProps }) => {
  const { radius, location, provinceOnly, setRadius, setProvinceOnly } =
    locationFormProps;
  const classes = useStyles();
  const { isDesktopWidth } = usePageWidth();

  const MenuComponent = isDesktopWidth ? MenuItem : "option";

  return (
    <div className={classes.form}>
      <LocationSearch
        clearInventoryCards={clearInventoryCards}
        location={location}
      />
      <FormControl fullWidth variant="outlined">
        <Select
          native={!isDesktopWidth}
          className={classes.radiusSelect}
          data-cy="radius-select"
          displayEmpty
          value={radius}
          onChange={(event) => {
            setRadius(event.target.value);
            clearInventoryCards();
          }}
          inputProps={{
            name: `${radius}-select`,
            id: `${radius}-select`,
          }}
        >
          <MenuComponent value={0}>No radius</MenuComponent>
          {radiuses.map((option) => (
            <MenuComponent
              key={option}
              data-cy={`${option}-item`}
              value={option}
            >
              {`+ ${option}km`}
            </MenuComponent>
          ))}
        </Select>
      </FormControl>

      <FormControlLabel
        label="Limit radius to province"
        control={
          <Checkbox
            disabled={!radius}
            checked={provinceOnly}
            onChange={() => setProvinceOnly(!provinceOnly)}
          />
        }
      />
    </div>
  );
};

export default LocationForm;
